<template></template>

<script>
import { AUTH_USER_STATE_UPDATE } from "Public/store/modules/auth";
import moment from "moment";
import userMixin from "Shared/mixins/userMixin";
import { appRoutes } from "Public/consts/appRoutes";
import {
  parseUserUpdateChannel,
  WebsocketUserEvents,
} from "Public/consts/websocket";
import { parseNotificationStatSum } from "PublicHelpers/Stat/User/parseStat";

export default {
  name: "Websockets",
  mixins: [userMixin],
  data() {
    return {
      lastNotificationPlayedAt: undefined,
      lastMessageReceivedPlayedAt: undefined,
    };
  },
  methods: {
    playNotificationReceivedSound() {
      const audio = new Audio("/-/public/sounds/notification.wav");
      audio.oncanplaythrough = () => {
        audio.play();
        this.lastNotificationPlayedAt = moment();
      };
    },
    wasMoreThan2MinutesAgo(time) {
      const diff = moment.duration(moment().diff(time)).asMinutes();
      return diff >= 2;
    },
    manageNotificationReceivedSound(payload, userState) {
      if (this.$route.path === appRoutes.notifications) return;

      if (this.checkNotificationStatSumChanged(payload, userState)) {
        if (!this.lastNotificationPlayedAt) {
          return this.playNotificationReceivedSound();
        }
        if (this.wasMoreThan2MinutesAgo(this.lastNotificationPlayedAt))
          this.playNotificationReceivedSound();
      }
    },
    checkNotificationStatSumChanged(payload, userState) {
      const userUpdates = { ...userState, ...payload };
      const currentCount = parseNotificationStatSum(userState);
      const updatesCount = parseNotificationStatSum(userUpdates);
      return updatesCount > currentCount;
    },
  },
  created() {
    if (this.user.id) {
      const updateChannel = parseUserUpdateChannel(this.user.id);
      Echo.private(updateChannel).listen(
        WebsocketUserEvents.dataUpdate,
        (payload) => {
          Object.keys(payload).forEach((key) => {
            if (!isNaN(payload[key])) {
              payload[key] = +payload[key];
            }
          });
          this.manageNotificationReceivedSound(payload, this.user);
          this.$store.commit(AUTH_USER_STATE_UPDATE, payload);
        }
      );

      Echo.private(updateChannel).listen(
        WebsocketUserEvents.messageUpdate,
        async () => {
          const audio = new Audio("/-/public/sounds/messageNotification.wav");
          audio.oncanplaythrough = () => {
            if (!this.lastMessageReceivedPlayedAt) {
              this.lastMessageReceivedPlayedAt = moment();
              return audio.play();
            }
            if (this.wasMoreThan2MinutesAgo(this.lastMessageReceivedPlayedAt)) {
              this.lastMessageReceivedPlayedAt = moment();
              return audio.play();
            }
          };
        }
      );

      Echo.private(updateChannel).listen(
        WebsocketUserEvents.proofToApprove,
        async () => {
          const audio = new Audio("/-/public/sounds/ding.wav");
          audio.oncanplaythrough = () => {
            audio.play();
          };
        }
      );
    }
  },
};
</script>

<style scoped></style>
